<!---->
<!---->
<!---->
<app-label-input [hasTooltip]="hasTooltip()" [required]="required()" [textTooltip]="textTooltip()"
   [textLabel]="textLabel()" />
<!---->
<!---->
<!---->
<!--DISABLED-->
@if(disabled()) {
<!---->
<!---->
<!---->
<div class="d-flex align-items-start gap-10">
   <!---->
   <mat-form-field class="w-100" appearance="outline">
      <input matInput [value]="value() ? value() : ''" disabled />
   </mat-form-field>
   <!---->
</div>
<!---->
<!---->
<!---->
} @else {
<!---->
<!---->
<!---->
<div class="d-flex align-items-start gap-10">
   <!---->
   <!---->
   <!---->
   <mat-form-field class="w-100 pointer-events-disable" appearance="outline">
      <input matInput [value]="fileName" [formControlName]="nameControl()!" placeholder="{{ placeholder() | translate}}"
         readonly />
      <input type="file" hidden [id]="nameControl()" (change)="selectFile($event)" [accept]="acceptAttribute" />
      <!---->
      <!---->
      <!---->
      @if(hasErrorMessage()) {
      <mat-error class="f-s-9">
         {{ getErrorMessage() }}
      </mat-error>
      }
   </mat-form-field>
   <!---->
   <!---->
   <!---->
   <label matTooltip="{{'SelectFile' | translate}}"
      class="bg-primary text-white d-flex align-items-center justify-content-center p-x-10 p-y-10 rounded c-pointer"
      [for]="nameControl()">
      <i-tabler name="paperclip" class="icon-20 stroke-1" />
   </label>
</div>
<!---->
<!---->
<!---->
}
